import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { useNavigate } from 'react-router-dom';
import Date from '../../../utils/date';
// import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


export default function CardNoticiaCaroussel({ noticia }) {
    const navigate = useNavigate()

    return (
        <CardActionArea
            title="Saiba mais.."
            onClick={() => navigate(`/view-noticia/${noticia?._id}`)}
            className="tw-relative tw-min-w-[180px] tw-w-full sm:tw-w-auto"
        >
            <Card className="tw-h-[350px]">
                <CardMedia
                    component="img"
                    alt="img"
                    height="200"
                    image={noticia?.imagem}
                    className="tw-transition-transform tw-duration-500 tw-ease-in-out hover:tw-scale-110 tw-object-cover"
                />
                <CardContent>
                    <Typography gutterBottom variant="subtitle2" component="div" className="tw-text-sm tw-leading-snug">
                        {noticia.titulo.length > 100 ? noticia.titulo.slice(0, 100) + '...' : noticia.titulo}
                    </Typography>
                </CardContent>

                <CardActions className="tw-absolute tw-bottom-5 tw-left-4 tw-flex tw-items-center tw-gap-2">
                    {/* <AccessTimeFilledIcon color='secondary' style={{ fontSize: '25px', padding: 2 }} /> */}
                    <CalendarMonthIcon
                                    sx={{
                                        fontSize: 18,
                                        color: '#85287e',
                                    }}
                                />
                    <Date date={noticia.updatedAt} />
                </CardActions>
            </Card>
        </CardActionArea>
    );
}